<template>
  <div class="ls_spin_container">
    <!-- SOURCE AND TARGET TABLES -->
    <Row :gutter="32">
      <!--SOURCE TABLE-->
      <Col :xs="24" :sm="24" :lg="8" v-if="action === 'create' || action === 'edit'">
        <!-- SEARCH -->
        <Input
          v-model="kit_composition.search_value"
          suffix="ios-search"
          placeholder="Введите наименование/артикул/код"
          style="width: 100%;"
          class="mb-30"
        />
        <div class="card-container card-container__one-col-table">


          <Table
            class="one-col-table desktop_table"
            :data="kit_composition.source_table.data"
            :columns="kit_composition.source_table.columns"
            :loading="kit_composition.source_table.loading"
            :show-header="false"
            @on-row-click="addToKitTargetTable"
          ></Table>

          <Table
            v-if="kit_composition.search_value"
            class="one-col-table mobile-table"
            :data="kit_composition.source_table.data"
            :columns="kit_composition.source_table.columns"
            :loading="kit_composition.source_table.loading"
            :show-header="false"
            @on-row-click="addToKitTargetTable"
          ></Table>


          <Button
            class="desktop_table"
            v-show="
              kit_composition.source_table.current_page *
                kit_composition.source_table.limit <
                kit_composition.source_table.total_records
            "
            style="width: 100%"
            type="info"
            @click="kit_composition.source_table.current_page++"
            >Показать еще
          </Button>
        </div>
      </Col>

      <!--TARGET TABLE-->
      <Col :xs="24" :sm="24" :md="24" :lg="16" class="target_table">
        <Form ref="formData" :model="formData" :rules="formDataRules">

          <Row type="flex" align="middle">

            <Col :xs="24" :sm="24" :md="0">
              <!--APPLIED-->
              <FormItem prop="applied" style="display: inline-block; margin-right: 24px">
                <div class="switch-custom">
                  <i-switch v-model="formData.applied"></i-switch>
                  <span>{{ applied_label }}</span>
                </div>
              </FormItem>
            </Col>

            <Col :xs="24" :sm="24" :md="0">
              <!--ORDER_DATE-->
              <FormItem prop="applied">
                <!--<template v-slot:label>-->
                <!--<span style="margin-left: 50px">{{-->
                <!--schema.order_date.label-->
                <!--}}</span>-->
                <!--</template>-->

                <DatePicker
                  :clearable="false"
                  type="datetime"
                  placeholder="Дата документа"
                  format="yyyy-MM-dd HH:mm"
                  :value="formData.order_date"
                  @on-change="setOrderDate"
                ></DatePicker>
              </FormItem>
            </Col>

          </Row>




          <h1>
            {{ order_type_labels[formData.type] }} №
            <input class="form__order_number" v-model="formData.number" />
          </h1>

          <Row :gutter="32" style="margin-top: 20px">
            <!--RECIPIENT-->
            <Col :xs="24" :sm="12">
              <FormItem
                :label="recipient_label"
                prop="recipient.id"
                v-if="action === 'create' || action === 'edit'"
              >
                <Select v-model="formData.recipient.id" filterable>
                  <OptionGroup label="Магазин">
                    <Option
                      v-for="item in formSelectOptions.store"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </OptionGroup>
                </Select>
              </FormItem>
              <!--<h2 v-if="action==='edit'">{{ recipient_label }}: {{ formData.recipient.name }}</h2>-->
            </Col>
          </Row>
        </Form>

        <div v-if="action === 'create' || action === 'edit'">
          <Tabs
            style="height: 100%;"
            v-if="kit_composition.target_table.length > 0"
          >
            <TabPane label="Товары">
              <div>
                <!-- TABLE OF SELECTED PRODUCTS-->

                <Row
                  class="desktop_table"
                  :gutter="10"
                  type="flex"
                  justify="space-between"
                  style="text-align: center; color: rgba(77,79,92,0.5); margin-bottom: 15px"
                >
                  <Col span="1">#</Col>
                  <Col span="6" style="text-align: left;">Наименование</Col>
                  <Col span="3" v-if="display_recipient_rest"
                    >Рассчетный остаток</Col
                  >
                  <Col span="3">Ед.изм.</Col>
                  <Col span="3">Факт.остаток</Col>
                  <Col span="3" v-if="display_recipient_rest">Расхождение</Col>
                  <Col
                    span="3"
                    v-if="display_recipient_rest"
                    style="text-align: right"
                    >Расхождение в деньгах</Col
                  >
                  <Col span="2"></Col>
                </Row>
                <Divider style="margin: 0 0 10px 0;"></Divider>

                <Row
                  class="desktop_table"
                  v-for="(product, counter) in kit_composition.target_table"
                  :key="product.id"
                  :gutter="10"
                  type="flex"
                  justify="space-between"
                  style="text-align: center;"
                >
                  <Divider v-if="counter > 0" style="margin: 13px 0;"></Divider>
                  <Col span="1" style="margin-top: 7px;">{{ counter + 1 }}</Col>
                  <Col span="6" style="text-align: left;margin-top: 7px;">{{
                    product.name
                  }}</Col>
                  <Col
                    span="3"
                    v-if="display_recipient_rest"
                    style="margin-top: 7px"
                    >{{ recipient_rest[product.id] }}</Col
                  >
                  <Col span="3" style="text-align: center;margin-top: 7px;">{{
                    product.unit ? product.unit : "-"
                  }}</Col>
                  <Col span="3" style="text-align: center;">
                    <InputNumber
                      @input="changeCountTargetTable($event, counter)"
                      :min="0"
                      :value="kit_composition.target_table[counter].count"
                    ></InputNumber>
                  </Col>
                  <Col
                    span="3"
                    v-if="display_recipient_rest"
                    style="text-align: center;margin-top: 7px"
                    >{{ itemDivergence(counter) }}</Col
                  >
                  <Col
                    span="3"
                    v-if="display_recipient_rest"
                    style="text-align: right;margin-top: 7px"
                    >{{ formatNumber(itemMoneyDivergence(counter)) }}</Col
                  >
                  <Col span="2" style="text-align: right;">
                    <Button
                      style="float: right; padding: 0; color: #EF6E57; box-shadow: none; border: none"
                      icon="md-trash"
                      @click="deleteFromKitTargetTable(product.id)"
                    ></Button>
                  </Col>
                </Row>


                <!-- MOBILE TABLE OF SELECTED PRODUCTS-->
                <div class="mobile-table">
                  <div class="card-container"
                       v-for="(product, counter) in kit_composition.target_table"
                       :key="product.id">
                    <div>
                      <h2>{{product.name}}</h2>

                      <p v-if="display_recipient_rest">
                        Рассчетный остаток: {{ recipient_rest[product.id] }}
                      </p>

                      <p>
                        Ед.изм.:
                        {{ product.unit ? product.unit : "-"}}
                      </p>

                      <p>
                        Факт.остаток:
                        <InputNumber
                          @input="changeCountTargetTable($event, counter)"
                          :min="0"
                          :value="kit_composition.target_table[counter].count"
                        ></InputNumber>
                      </p>

                      <p  v-if="display_recipient_rest">
                        Расхождение: {{ itemDivergence(counter) }}
                      </p>

                      <p v-if="display_recipient_rest">
                        Расхождение в деньгах: {{ formatNumber(itemMoneyDivergence(counter)) }}
                      </p>
                    </div>

                    <div>
                      <Button
                        style="float: right; padding: 0; color: #EF6E57; box-shadow: none; border: none"
                        icon="md-trash"
                        @click="deleteFromKitTargetTable(product.id)"
                      ></Button>
                    </div>

                  </div>
                </div>

                <Divider></Divider>

                <!-- TOTAL ROWS -->
                <div style="margin-top: 50px">
                  <h2>Общий итог</h2>

                  <!--ITEM COUNT-->
                  <Row :gutter="32" class="total_row">
                    <Col span="12">
                      Всего позиций:
                    </Col>
                    <Col span="12" style="text-align: right;">
                      {{ item_count }}
                    </Col>
                  </Row>

                  <!--DIVERGENCE COUNT-->
                  <Row
                    :gutter="32"
                    class="total_row"
                    v-if="display_recipient_rest"
                  >
                    <Col span="12">
                      Количество позиций с расхождением:
                    </Col>
                    <Col span="12" style="text-align: right;">
                      {{ divergence_count }}
                    </Col>
                  </Row>

                  <!--CALC SUM-->
                  <Row
                    :gutter="32"
                    v-if="display_recipient_rest"
                    class="total_row"
                  >
                    <Col span="12">
                      Расчётная сумма:
                    </Col>
                    <Col span="12" style="text-align: right;">
                      {{ formatNumber(calc_total_sum.toFixed(2)) }}
                      {{ currency }}
                    </Col>
                  </Row>

                  <!--TOTAL SUM-->
                  <Row :gutter="32" class="total_row">
                    <Col span="12">
                      Фактическая сумма:
                    </Col>
                    <Col span="12" style="text-align: right;">
                      {{ formatNumber(actual_total_sum.toFixed(2)) }}
                      {{ currency }}
                    </Col>
                  </Row>

                  <!--DIVERGENCE SUM-->
                  <Row
                    :gutter="32"
                    v-if="display_recipient_rest"
                    class="total_row"
                  >
                    <Col span="12">
                      Сумма расхождений:
                    </Col>
                    <Col span="12" style="text-align: right;">
                      {{ formatNumber(divergence_sum.toFixed(2)) }}
                      {{ currency }}
                    </Col>
                  </Row>

                  <Row
                    :gutter="32"
                    type="flex"
                    justify="space-between"
                    v-if="display_recipient_rest"
                  >
                    <Divider></Divider>
                    <Col :xs="24" :sm="24" :md="10" class="mb-24">
                      <h2>Недостача</h2>
                      <!--DIVERGENCE SUM-->
                      <Row :gutter="32" class="total_row">
                        <Col span="12">
                          Количетсво наименований:
                        </Col>
                        <Col span="12" style="text-align: right;">
                          {{ formatNumber(deficit_count.toFixed(2)) }}
                        </Col>
                      </Row>
                      <!--DIVERGENCE SUM-->
                      <Row :gutter="32" class="total_row">
                        <Col span="12">
                          Сумма:
                        </Col>
                        <Col span="12" style="text-align: right;">
                          {{ formatNumber(deficit_total_sum.toFixed(2)) }}
                          {{ currency }}
                        </Col>
                      </Row>
                    </Col>
                    <Col :xs="24" :sm="24" :md="10">
                      <h2>Излишки</h2>
                      <!--DIVERGENCE SUM-->
                      <Row :gutter="32" class="total_row">
                        <Col span="12">
                          Количество наименований:
                        </Col>
                        <Col span="12" style="text-align: right;">
                          {{ formatNumber(over_count.toFixed(2)) }}
                        </Col>
                      </Row>
                      <!--DIVERGENCE SUM-->
                      <Row :gutter="32" class="total_row">
                        <Col span="12">
                          Сумма:
                        </Col>
                        <Col span="12" style="text-align: right;">
                          {{ formatNumber(over_total_sum.toFixed(2)) }}
                          {{ currency }}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>

                <!-- DESCRIPTION FORM-->
                <Form :model="formData" style="margin-top: 20px; padding: 5px">
                  <!-- DESCRIPTION -->
                  <FormItem>
                    <Input
                      type="textarea"
                      v-model="formData.description"
                      :rows="4"
                      placeholder="Комментарий"
                    />
                  </FormItem>
                </Form>
              </div>
            </TabPane>
          </Tabs>

          <div
            v-else
            class="no-select"
          >
            <span class="desktop_table">
              <Icon type="md-arrow-back" />
              Выберите товары
            </span>

            <span class="mobile-table">

              <Icon type="md-arrow-up" /> <br>
              Выберите товары <br> (введите наименование в строке поиска)
            </span>
          </div>


        </div>
        <!--<div v-if="action === 'edit'">-->
        <!--<div>-->
        <!--&lt;!&ndash; TABLE OF PRODUCTS&ndash;&gt;-->
        <!--<Row-->
        <!--:gutter="10"-->
        <!--type="flex"-->
        <!--justify="space-between"-->
        <!--style="text-align: center; color: gray"-->
        <!--&gt;-->
        <!--<Col span="2">#</Col>-->
        <!--<Col span="13" style="text-align: left;">Наименование</Col>-->
        <!--<Col span="6">Ед.изм.</Col>-->
        <!--<Col span="3">Количество</Col>-->
        <!--&lt;!&ndash;<Col span="4">Цена</Col>&ndash;&gt;-->
        <!--&lt;!&ndash;<Col span="3" style="text-align: right;">Всего</Col>&ndash;&gt;-->
        <!--</Row>-->
        <!--<Divider style="margin: 0 0 10px 0;"></Divider>-->

        <!--<Row-->
        <!--v-for="(product, counter) in kit_composition.target_table"-->
        <!--:key="product.id"-->
        <!--:gutter="10"-->
        <!--type="flex"-->
        <!--justify="space-between"-->
        <!--style="text-align: center;"-->
        <!--&gt;-->
        <!--<Divider v-if="counter > 0" style="margin: 13px 0;"></Divider>-->
        <!--<Col span="2">{{ counter + 1 }}</Col>-->
        <!--<Col span="13" style="text-align: left;">{{ product.name }}</Col>-->
        <!--<Col span="6" style="text-align: center;">{{-->
        <!--product.unit ? product.unit : "-"-->
        <!--}}</Col>-->
        <!--<Col span="3" style="text-align: center;">-->
        <!--{{ formatNumber(kit_composition.target_table[counter].count) }}-->
        <!--</Col>-->
        <!--&lt;!&ndash;<Col span="4">&ndash;&gt;-->
        <!--&lt;!&ndash;{{ formatNumber(kit_composition.target_table[counter].base_price) }}&ndash;&gt;-->
        <!--&lt;!&ndash;</Col>&ndash;&gt;-->

        <!--&lt;!&ndash;<Col span="3" style="text-align: right;"&ndash;&gt;-->
        <!--&lt;!&ndash;&gt;{{ formatNumber(product.total_price) }} {{ currency }}</Col&ndash;&gt;-->
        <!--&lt;!&ndash;&gt;&ndash;&gt;-->
        <!--</Row>-->

        <!--&lt;!&ndash; DESCRIPTION FORM&ndash;&gt;-->
        <!--<Form :model="formData" style="margin-top: 20px">-->
        <!--&lt;!&ndash;DESCRIPTION &ndash;&gt;-->
        <!--<FormItem>-->
        <!--<Input-->
        <!--type="textarea"-->
        <!--v-model="formData.description"-->
        <!--:rows="4"-->
        <!--:placeholder="schema.description.label"-->
        <!--/>-->
        <!--</FormItem>-->
        <!--</Form>-->
        <!--</div>-->
        <!--</div>-->

        <Button
          style="display: inline-block;"
          type="success"
          @click="save"
          :disabled="disabled_save_button"
        >Сохранить
        </Button>
      </Col>
    </Row>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { order_type_labels } from "./order_type_list.js";
import { base_url } from "../../http.js";
import { formatNumber } from "../../base/base_func.js";
import { TYPE_CHANGES_INVENTORY, BASE_PRICE, PURCHASE_PRICE } from "./const.js";

const CATALOG_TYPE_PRODUCT = 'PRODUCT';

export default {
  name: "productOrderFormInventory",
  data() {
    return {
      PRICE_ATTR: PURCHASE_PRICE,
      base_view_url: base_url + "/product_order/inventory/",
      action: "create",
      id: "",
      loading: true,

      // Объект, отправляемый в бэк
      formData: {
        type: TYPE_CHANGES_INVENTORY,
        number: "",
        applied: false,
        order_date: new Date(),
        recipient: {
          type: "store",
          id: ""
        },

        // sender_id: '',
        // recipient_id: '',

        positions: []
      },

      // Вспомогательный объект для хранения промежуточной информации о комплекте
      kit_composition: {
        search_value: "",
        source_table: {
          columns: [
            {
              key: "name",
              className: "kit_source_table_column",
              render: (h, params) => {
                return h("div", [
                  h("div", {}, params.row.name),
                  h(
                    "span",
                    {
                      style: { color: "#a4a4a4" }
                    },
                    formatNumber(params.row[this.PRICE_ATTR]) +
                      " " +
                      this.currency
                  )
                ]);
              }
            }
          ],
          data: [],
          total_records: 0,
          last_draw: 0,
          loading: false,
          current_page: 1,
          limit: 15
        },
        target_table: []
      },
      order_type_labels: order_type_labels,

      formSelectOptions: {
        store: []
      },
      is_order: false,
      individual_total_discount: 0,

      validForm: false,
      isChanged: false,
      formDataRules: {
        "recipient.id": [
          {
            required: true,
            message: "Пожалуйста, выберите получателя",
            trigger: "change",
            // type: "number"
          }
        ]
      }
    };
  },
  asyncComputed: {
    schema: {
      get() {
        return this.$http.options(this.base_view_url).then(response => {
          return response.data.actions.POST;
        });
      }
    }
  },
  computed: {
    applied_label() {
      return this.formData.applied
        ? "Документ проведен"
        : "Документ не проведен";
    },

    display_recipient_rest() {
      return this.recipient_store_name !== "";
    },
    recipient_store_name() {
      for (let item of this.formSelectOptions.store) {
        if (item.id === this.formData.recipient.id) {
          return item.name;
        }
      }
      return "";
    },
    recipient_rest() {
      let rest = {};
      for (let item of this.kit_composition.target_table) {
        // if (this.formData.sender.id !== this.formData.recipient.id) {
          let r = parseFloat(item.rest_by_stores[this.formData.recipient.id]);
          rest[item.id] = !isNaN(r) ? r: parseFloat(item.rest_by_stores[this.formData.recipient.id]);
        // } else {
        //   rest[item.id] = parseFloat(item.rest_by_stores[this.formData.recipient.id]);
        // }
      }
      return rest;
    },
    currency() {
      return this.$store.state.currency;
    },
    disabled_save_button() {
      if (this.action === "create") {
        return (
          this.kit_composition.target_table.length === 0 || !this.validForm
        );
      } else if (this.action === "edit") {
        // return !this.isChanged;
          return (
              this.kit_composition.target_table.length === 0 || !this.validForm
          );
      }
    },
    recipient_label() {
      return "Магазин";
    },

    // Итоговые цифры по заказу
    item_count() {
      return this.kit_composition.target_table.length;
    },
    divergence_count() {
      let count = 0;
      this.kit_composition.target_table.forEach((item, index) => {
        if (item.count !== this.recipient_rest[item.id]) count++;
      });
      return count;
    },
    calc_total_sum() {
      let sum = 0;
      this.kit_composition.target_table.forEach((item, index) => {
        sum += parseFloat(this.recipient_rest[item.id] * item.base_price);
      });
      return sum;
    },
    actual_total_sum() {
      let sum = 0;
      // for (let item of this.kit_composition.target_table) {
      //   sum += parseFloat(item.total_price);
      // }
      this.kit_composition.target_table.forEach((item, index) => {
          // console.log('item.count', item.count);
          // console.log('item[this.PRICE_ATTR]', item[this.PRICE_ATTR]);
        sum += item.count * item.base_price;
      });

      return sum;
    },
    divergence_sum() {
      return this.actual_total_sum - this.calc_total_sum;
    },

    // Недостача
    deficit_count() {
      let count = 0;
      this.kit_composition.target_table.forEach((item, index) => {
        if (item.count - this.recipient_rest[item.id] < 0) count++;
      });
      return count;
    },
    deficit_total_sum() {
      let sum = 0;
      this.kit_composition.target_table.forEach((item, index) => {
        if (item.count - this.recipient_rest[item.id] < 0) {
          let money = parseFloat(this.itemMoneyDivergence(index));
          // console.log('deficit_total_sum: ', money);
          sum += money;
        }
      });
      return sum;
    },

    // Излишки
    over_count() {
      let count = 0;
      this.kit_composition.target_table.forEach((item, index) => {
        if (item.count - this.recipient_rest[item.id] > 0) count++;
      });
      return count;
    },
    over_total_sum() {
      let sum = 0;
      this.kit_composition.target_table.forEach((item, index) => {
        if (item.count - this.recipient_rest[item.id] > 0) {
          let money = parseFloat(this.itemMoneyDivergence(index));
          // console.log('deficit_total_sum: ', money);
          sum += money;
        }
      });
      return sum;
    }
  },
  methods: {
    // Получение спсика товаров для формирования заказа
    fetchProductsForKit(filtered = false) {
      const url = base_url + "/catalog/products/";
      this.kit_composition.source_table.loading = true;
      this.kit_composition.source_table.last_draw++;

      let params = {
        format: "table",
        type: CATALOG_TYPE_PRODUCT,
        draw: this.kit_composition.source_table.last_draw,
        offset:
          this.kit_composition.source_table.limit *
            this.kit_composition.source_table.current_page -
          this.kit_composition.source_table.limit,
        limit: this.kit_composition.source_table.limit,
        search: this.kit_composition.search_value
      };

      this.$http
        .get(url, { params: params })
        .then(result => {
          if (
            result.data.draw === this.kit_composition.source_table.last_draw
          ) {
            if (filtered) {
              this.kit_composition.source_table.data = result.data.results;
            } else {
              for (let product of result.data.results) {
                this.kit_composition.source_table.data.push(product);
              }
            }

            this.kit_composition.source_table.total_records = result.data.count;
          }
        })
        .finally(() => {
          this.kit_composition.source_table.loading = false;
        });
    },

    // Добавление товрара в заказ
    addToKitTargetTable(data, index) {
      for (const [
        counter,
        item
      ] of this.kit_composition.target_table.entries()) {
        if (item.id === data.id) {
          this.kit_composition.target_table[counter].count++;

          let count = this.kit_composition.target_table[counter].count;
          this.kit_composition.target_table[counter].total_price =
            parseFloat((data[this.PRICE_ATTR] * count).toFixed(2));
          return;
        }
      }

      // Добавляем значения по-умолчанию
      let rest_by_stores = {};
      for (const store of this.formSelectOptions.store) {
        rest_by_stores[store.id] = 0;
      }

      let number_inc = this.kit_composition.target_table.length + 1;
      this.kit_composition.target_table.push({
        number_inc: number_inc,
        id: data.id,
        name: data.name,
        code: data.code,
        unit: data.unit,
        base_price: data[this.PRICE_ATTR],
        // purchase: data.purchase,
        // rest_sender: 0,
        // rest_recipient: 0,
        rest_by_stores: rest_by_stores,
        count: 0,
        // calc_count: 0,
        total_price: 0
      });

      this.fetchProductRest(data.id);
    },

    // Удаление товара из целеыой таблицы (КОМПЛЕКТ)
    deleteFromKitTargetTable(id) {
      for (const [
        counter,
        item
      ] of this.kit_composition.target_table.entries()) {
        if (item.id === id) {
          this.kit_composition.target_table.splice(counter, 1);
          return;
        }
      }
    },

    // Измнение кол-ва, цены, скидки по товару
    changeCountTargetTable(count, row_count) {
      this.kit_composition.target_table[row_count].count = count;
      // this.changeTotalPriceTargetTable(row_count);
    },

    // Справочники
    getStores() {
      const url = base_url + "/options/stores/";
      this.$http
        .get(url)
        .then(result => {
          this.formSelectOptions.store = result.data.results;
        })
        .catch(error => {
          this.$Message.error("Ошибка получения списка покупателей");
        })
          .then(() => {
              if (this.action === 'edit') {
                  // Добавляем значения по-умолчанию
                  let rest_by_stores = {};
                  for (const store of this.formSelectOptions.store) {
                      rest_by_stores[store.id] = 0;
                  }

                  this.kit_composition.target_table.forEach((item, index)=>{
                      this.kit_composition.target_table[index].rest_by_stores = rest_by_stores;
                      // Vue.set(this.kit_composition.target_table[index], "rest_by_stores", rest_by_stores)
                  })
              }
          });
    },

    handleDataBeforeSave(formData) {
      let data = formData;
      data.positions = [];

      // for (let item of this.kit_composition.target_table) {
      //   data.positions.push({
      //     product: item.id,
      //     name: item.name,
      //     code: item.code,
      //     amount: (this.kit_composition.target_table[counter].count - this.recipient_rest[product.id]).toFixed(2)
      //     // amount: item.count.toFixed(2)
      //   });
      // }

      this.kit_composition.target_table.forEach((item, index) => {
        data.positions.push({
          product: item.id,
          name: item.name,
          code: item.code,
          amount: this.itemDivergence(index),
          base_price: item.base_price,
          total_price: this.itemMoneyDivergence(index)
          // amount: item.count.toFixed(2)
        });
      });

      // formData.money_orders.forEach((item, idx)=> {
      //   data.money_orders[idx] = {
      //     applied: item.applied,
      //     account: item.account,
      //     sum: item.sum.toFixed(2),
      //     date: item.date
      //   };
      // });

      data.total_sum = this.divergence_sum.toFixed(2);
      return data;
    },

    save() {
      let http_method = "put";
      let url = `${this.base_view_url}${this.id}/`;

      if (this.action === "create") {
        http_method = "post";
        url = this.base_view_url;
      }

      let data = this.handleDataBeforeSave(this.formData);
      // console.log("data", data);

      this.loading = true;
      this.$http[http_method](url, data)
        .then(response => {
          this.$Message.success("Успешно сохранено");
          this.$router.push({
            name: "product_order_detail",
            params: { id: response.data.id }
          });
          // this.showDetail(response.data.id);
          // if (this.action === "create") {
          //   this.$emit("change", response.data.id);
          // }
          // this.$emit("reload_table");
        })
              .finally(() => {
                this.loading = false;
              });
    },

    formatNumber(number) {
      return formatNumber(number);
    },

    setOrderDate(date_str, date2) {
      this.formData.order_date = date_str;
    },

    fetchProductRest(product_id) {
      const path = `/catalog/products/${product_id}/`;
      this.$http
        .get(base_url + path)
        .then(result => {
          if (result.data.rest_by_stores.length > 0) {
            if (this.action === "create") {
              for (const [
                counter,
                item
              ] of this.kit_composition.target_table.entries()) {
                if (item.id === product_id) {
                  for (const item of result.data.rest_by_stores) {
                    this.kit_composition.target_table[counter].rest_by_stores[
                      item.store
                    ] = item.value;
                  }
                  return;
                }
              }
            } else {
              for (const [
                index,
                item
              ] of this.kit_composition.target_table.entries()) {
                if (item.id === product_id) {
                  // console.log(1122);
                  for (const item of result.data.rest_by_stores) {
                    // console.log("item", item.store);
                    this.kit_composition.target_table[index].rest_by_stores[
                      item.store
                    ] = item.value;
                  }

                  if (item.from_db) {
                      this.kit_composition.target_table[index].count = (
                          this.kit_composition.target_table[index].amount + this.recipient_rest[item.id]
                      ).toFixed(2);
                  }

                  return;
                }
              }
            }
          }
        })
    },

    validateForm() {
      this.$refs.formData.validate(valid => {
        this.validForm = valid;
      });
    },

    fetchInitialData() {
      this.$http
        .get(this.base_view_url + this.id)
        .then(response => {
          this.formData = response.data;
        })
        .then(() => {
          if (this.formData.state) {
            this.is_order = true;
          }

          this.processInitialData();

          // while (this.formSelectOptions.store.length === 0) {
          //   setTimeout(this.processInitialData, 1000);
          // }

          //this.processInitialData();

          // Добавляем вотчеры на поля (для корректной работы добавляем после заполнекния формы)
          this.$watch("formData.state", function() {
            this.isChanged = true;
          });
          this.$watch("formData.order_date", function() {
            this.isChanged = true;
          });
          this.$watch("formData.applied", function() {
            this.isChanged = true;
          });
          this.$watch("formData.description", function() {
            this.isChanged = true;
          });
        })
              .finally(() => {
                this.loading = false;
              });
    },
    processInitialData() {
      this.formData.positions.forEach((value, index) => {
        let rest_by_stores = {};
        for (const store of this.formSelectOptions.store) {
          rest_by_stores[store.id] = 0;
        }

        this.kit_composition.target_table.push({
          id: value.product,
          name: value.name,
          code: value.code,
          unit: value.unit,
          base_price: value.base_price,
          // purchase: value.purchase,
          total_price: value.base_price * value.amount,
          // count: (value.amount + this.recipient_rest[item.id]).toFixed(2),
          amount: value.amount,
          count: 0,
          // calc_count: 0,
          rest_by_stores: rest_by_stores,
          from_db: true,
        });

        this.fetchProductRest(value.product);
      });
    },

    itemDivergence(index) {
      let item = this.kit_composition.target_table[index];
      // console.log("item11", item);
      // console.log("count", item.count);
      // console.log("recipient_rest", this.recipient_rest[item.id]);
      return (item.count - this.recipient_rest[item.id]).toFixed(2);
    },
    itemMoneyDivergence(index) {
      let item = this.kit_composition.target_table[index];
      return (this.itemDivergence(index) * item['base_price']).toFixed(2);
    }
  },

  // Поиск товара для набора (КОМПЛЕКТ)
  watch: {
    "kit_composition.search_value": function() {
      this.kit_composition.source_table.current_page = 1;
      this.fetchProductsForKit(true);
    },
    "kit_composition.source_table.current_page": function() {
      this.fetchProductsForKit();
    },
    "formData.recipient.id": function(to, from) {
      this.validateForm();
      // this.isChanged = true;
    }
  },

  mounted() {
    switch (this.$route.name) {
      case "product_order_inventory_create":
        this.action = "create";
        this.fetchProductsForKit();
        break;
      case "product_order_inventory_edit":
        this.action = "edit";
        this.fetchProductsForKit();

        this.id = this.$route.params.id;
        this.fetchInitialData();
        break;
    }
      this.getStores();
    this.loading = false;
  }
};
</script>

<style scoped>
.form__order_number {
  width: 100px;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom-style: dashed;
  border-bottom-width: 2px;
}
.total_row {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
}

.no-select {
  text-align: center;
  font-size: 28px;
  color: rgba(191,191,191,.87);
  margin-top: 20px;
  margin-bottom: 20px;
}

.switch-custom span.ivu-switch {
  margin-left: 0;
}


.card-container__one-col-table {
  padding: 10px 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}


@media screen and (max-width: 1500px) {
  .total_row {
    font-size: 14px
  }

  .no-select {
    font-size: 20px;
  }
}

@media screen and (max-width: 991px) {
  .card-container__one-col-table {
    padding: 0;
    box-shadow: none;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    /*margin-bottom: 30px;*/
  }

  .mobile-table .card-container {
    margin: 0 5px 10px 5px;
  }
  .mobile-table .card-container p {
    margin-bottom: 10px;
  }

  .target_table .ivu-input-number {
    padding: 2px 5px;
    font-size: 12px;
    margin-left: 10px;
    max-width: 80px;
    width: auto;
  }

  .no-select {
    margin-top: 50px;
    margin-bottom: 50px;
  }


}


</style>
<style>
.kit_source_table_column {
  cursor: pointer;
}
.ls_source_table {
  height: 699px;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #dcdee2 !important;
}


@media screen and (max-width: 991px) {
  .ivu-input-number-handler-wrap {
    display: none;
  }

  .mobile-table .ivu-input-number-input-wrap {
    height: auto;
  }

  .mobile-table .ivu-input-number-input {
    height: auto;
    line-height: 1;
  }

}

@media screen and (max-width: 767px) {
  .ivu-date-picker {
    width: 100%;
  }
  .datepicker_input {
    width: 100%;
  }
}

@media screen and (min-width: 768px) {
  .ivu-col-span-md-0 {
    display: block;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/product_order/productOrderFormInventory.vue